import {
  ListBanksDto,
  ListBanksResponseDto
} from '@features/setting/application/use_cases/list-banks/dto/list-banks.response.dto';
import {ListBanksPayloadDto} from '@features/setting/application/use_cases/list-banks/dto/list-banks.payload.dto';

import {
  ListBanksHttpDto,
  ListBanksHttpResponseDto
} from '@features/setting/infrastructure/http/list-banks/list-banks.http.response.dto';
import {ListBanksHttpPayloadDto} from '@features/setting/infrastructure/http/list-banks/list-banks.http.payload.dto';

export class ListBanksHttpMapper {

  static toResponse(data: ListBanksHttpResponseDto): ListBanksResponseDto {
    return {
      data: data.data.map(item => {
        return {
          code: item.code,
          name: item.name,
          is_wallet: item.is_wallet == 1
        }
      }),
    }
  }

  static toInfra(data: ListBanksPayloadDto): ListBanksHttpPayloadDto {
    return {}
  }

  static mapItem(item: ListBanksHttpDto): ListBanksDto {
    return {
      code: item.name,
      name: item.code,
      is_wallet: item.is_wallet == 1
    }
  }

}
